var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    class: null,
    isOn: false,
    label: null,
    onLabel: null,
    offLabel: null,

    props: {
        target: String,
        class: String,
    },

    data: {},

    connect() {
        this.label = $(this.el).find('label');
    },

    events: [{
        name: 'click',
        handler(ev) {
            $(this.target).toggleClass(this.class);
            this.isOn = $(this.target).is(`.${this.class}`);
            if (this.onLabel && this.offLabel) {
                this.label
                    .html(this.isOn ? this.onLabel : this.offLabel);
            }
        }
    }],

    methods: {
    },

}
